import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import KYBSummaryCompanyName from 'assets/images/company/summary.svg';
import TabTitle from '../../../../TabTitle';

const I18N_BASE_PATH =
  'pages.private.KYBCompany.pages.companyDetails.subPages.companyInfo';

const CompanyInfoTabTitle = ({ companyName }) => {
  const { t: translate } = useTranslation();

  return (
    <TabTitle
      icon={KYBSummaryCompanyName}
      title={translate(`${I18N_BASE_PATH}.title`, 'Company info')}
      subtitle={
        <Trans
          i18nKey={`${I18N_BASE_PATH}.subTitle`}
          values={{ companyName }}
          components={{ b: <b /> }}
        />
      }
    />
  );
};

export default CompanyInfoTabTitle;
